import React, { Component } from 'react';
import Swal from 'sweetalert2';
import './Scanqr.css';
import { Html5Qrcode } from 'html5-qrcode';
import axios from 'axios';
import QRScanner from './QRScanner';
import NewQRScanner from './NewQRScanner';

const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000
});

export default class NewScanQR extends Component {
  constructor() {
    super();
    this.state = {
      scanResultData: "",
      scanResultWebCam: "",
      clickedOnScan: true,
      words: {},
      lang: "",
      Client: "",
      isScannerRunning: false, // New state variable to track if the scanner is running
    }
    this.handleScanWebCam = this.handleScanWebCam.bind(this);
    this.html5QrCode = null;
    this.qrCodeRegionId = "html5qr-code-full-region";
    this.fileInputRef = React.createRef();
  }

  async componentDidMount() {
    await this.getLang();
    if (this.props.legacyMode) {
      this.openFileUpload();
    }
  }
  

  componentDidUpdate(prevProps) {
    if (this.props.legacyMode && !prevProps.legacyMode) {
      this.openFileUpload();
    }
  }
  

  componentWillUnmount() {
    if (this.html5QrCode && this.state.isScannerRunning) {
      this.html5QrCode.stop().then(() => {
        this.html5QrCode.clear();
      }).catch((err) => {
        console.error("Failed to clear html5QrCode. Reason: ", err);
      });
    }
  }

  getLang = () => {
    const base_url = window.location.origin;
    axios.get(`${base_url}/lang.json`).then((res) => {
      this.setState({ words: res.data, lang: localStorage.getItem("lang") });
    });
  };

  lang = (word) => {
    const { lang, words } = this.state;
    return words[word] ? words[word][lang] : word;
  };

  handleError = (error) => {
    console.error(error);
  }

  handleScanWebCam(result) {
    const { legacyMode } = this.props;
    if (result) {
      let Data = result;
      let stringCorrect = result.includes('client') || result.includes('claimNumber') || result.includes('Firma') || result.includes('OrderNo') || result.includes('RegNo') || result.includes('Color') || result.includes('PartnerName') || result.includes('Model') || result.includes("ActualVin") || result.includes("Make");
      let stringUSCorrect = result.includes('Auftragsgeber') || result.includes('claimNumber') || result.includes('Firma') || result.includes('OrderNo') || result.includes('KZ') || result.includes('Farbe') || result.includes('Name') || result.includes('Typ') || result.includes("VIN") || result.includes("Marke");
      let stringCorrectForSlovina = result.includes('estimateID') || result.includes('vin') || result.includes('regno') || result.includes('make') || result.includes('model') || result.includes('color');
      var setClient = '';
      if (stringCorrect || stringCorrectForSlovina || stringUSCorrect) {
        if (localStorage.getItem("client") === "SWISS") {
          if (result.includes("Mobiliar")) {
            setClient = "Mobiliar";
            this.setState({ Client: "Mobiliar" });
          } else if (result.includes("client=&")) {
            setClient = "";
            this.setState({ Client: "" });
          } else {
            setClient = "amag";
            this.setState({ Client: "amag" });
          }
        }
        result = result.replaceAll('"', '');
        result = stringCorrectForSlovina ? result.split(';') : result.split('&');
        result = result.map((r) => r.split('='));
        this.props.handleScanWebCam(result, Data, setClient);
        this.setState({
          scanResultWebCam: Data,
          clickedOnScan: false
        });
      } else {
        Toast.fire({
          icon: 'error',
          title: 'Your QR is malformed. Please try again later.'
        }).then(() => {
          this.props.handleScanWebCam();
        });
      }
    } else if (legacyMode && result === null) {
      Toast.fire({
        icon: 'warning',
        title: this.lang('Upload/Scan valid QR!')
      }).then(() => {
        this.props.handleScanWebCam();
      });
    }
  }

  openFileUpload = () => {
    if (this.fileInputRef.current) {
      this.fileInputRef.current.click();
    }
  }

  onFileChange = (event) => {
    if (event.target.files.length === 0) {
      return;
    }

    const file = event.target.files[0];
    if (!this.html5QrCode) {
      this.html5QrCode = new Html5Qrcode(this.qrCodeRegionId);
    }

    this.html5QrCode.scanFile(file, true)
      .then(decodedText => {
        this.handleScanWebCam(decodedText);
      })
      .catch(err => {
        this.handleError(err);
        Toast.fire({
          icon: 'error',
          title: 'Failed to scan QR code. Please try again.'
        });
      });
  }

  // startScan = () => {
  //   this.setState({ clickedOnScan: true, scanResultWebCam: "" });
  //   this.html5QrCode = new Html5Qrcode(this.qrCodeRegionId);
  //   const qrCodeSuccessCallback = (decodedText, decodedResult) => {
  //     this.handleScanWebCam(decodedText);
  //   };
  //   const config = { fps: 10, qrbox: 250 };
  //   this.html5QrCode.start({ facingMode: "environment" }, config, qrCodeSuccessCallback)
  //     .then(() => {
  //       this.setState({ isScannerRunning: true });
  //     })
  //     .catch(this.handleError);
  // }

  render() {
    const { legacyMode } = this.props;
    return (
      <div>
        <div id={this.qrCodeRegionId} style={{ display: legacyMode ? 'none' : 'block' }}></div>
        {!legacyMode &&        
        <NewQRScanner handleScanWebCam={(result) => this.handleScanWebCam(result)}/> }
        {legacyMode &&
          <input
            type="file"
            accept="image/*"
            ref={this.fileInputRef}
            style={{ display: 'none' }}
            onChange={this.onFileChange}
            onClick={(e) => { e.target.value = null }}  // Clear the input value to trigger onChange event even if the same file is selected again
          />
        }
      </div>
    );
  }
}
